import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../../../button";
import { NEW_RESIDENT } from "./types";
import { Text } from "../../../text";
import { NavLink } from "../../../navigation";
import { theme } from "../../../theme";
export const ManageResidentButton = ({ linkedResidentId, }) => {
    const invalidateResidentNavigation = !linkedResidentId || linkedResidentId === NEW_RESIDENT;
    return (_jsx(Button, { type: "link", style: {
            cursor: invalidateResidentNavigation ? "not-allowed" : "auto",
            marginBottom: "8px",
            marginTop: "16px",
        }, disabled: invalidateResidentNavigation, children: invalidateResidentNavigation ? (_jsx(Text, { style: {
                cursor: "not-allowed",
                color: theme.color.gray100,
                textDecoration: "underline",
            }, children: "Manage Resident" })) : (_jsx(NavLink, { style: {
                color: theme.color.primary,
                textDecoration: "underline",
            }, to: `/admin/residents/${linkedResidentId}`, children: "Manage resident" })) }));
};
